import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginComponent } from './pages/login/login.component';
import { LoginComponent as LoginInnerComponent } from './components/login/login.component';
import { LandingComponent } from './pages/landing/landing.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from './core/core.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSelectModule } from '@angular/material/select';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TaskSelectorComponent } from './components/landing/task-selector/task-selector.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoaderInterceptor } from './core/interceptors/loader.interceptor';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { SettingsComponent } from './components/settings/settings.component';
import { UnauthorisedComponent } from './components/unauthorised/unauthorised.component';
import { LogoutComponent } from './components/logout/logout.component';
import { TimeOutComponent } from './components/time-out/time-out.component';
import * as echarts from 'echarts';
import { NgxEchartsModule } from 'ngx-echarts';
import { LandingCardComponent } from './pages/Components/landing-card/landing-card.component';
import { NpnSliderModule } from 'npn-slider';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { KeycloakBearerInterceptor } from './core/interceptors/keycloakInterceptor';
import { initializeKeycloak } from './core/init/keycloak-init.factory';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { OmniComponent } from './components/pages/Components/omni/omni.component';
import { ReportComponent } from './components/pages/Components/report/report.component';
import { Router } from '@angular/router';
// import { DistIntOverallTopdropdownComponent } from './modules/Distribution/distribution-international-overall/dist-int-overall-topdropdown/dist-int-overall-topdropdown.component';


import { RequestAccessComponent } from './components/request-access/request-access.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LandingComponent,
    LoginInnerComponent,
    TaskSelectorComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    SettingsComponent,
    UnauthorisedComponent,
    LogoutComponent,
    TimeOutComponent,
    LandingCardComponent,
    OmniComponent,
    ReportComponent,
    RequestAccessComponent,

    // DistnIntOvelDropdownComponent
    // DistIntOverallTopdropdownComponent,    RequestAccessComponent,


  ],

  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CoreModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    MatIconModule,
    MatCheckboxModule,
    FlexLayoutModule,
    MatSelectModule,
    MatGridListModule,
    NpnSliderModule,
    KeycloakAngularModule,
    MatMenuModule,
    MatTooltipModule,
    NgxEchartsModule.forRoot({
      echarts,
    }),
  ],
  providers: [
    TitleCasePipe,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },


    {
      provide: HTTP_INTERCEPTORS,
      useClass: KeycloakBearerInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService]
    }
    // { provide: LocationStrategy, useClass: HashLocationStrategy },

  ],
  bootstrap: [AppComponent],

    // { provide: LocationStrategy, useClass: HashLocationStrategy },

})
export class AppModule {}
